<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'CONTRACTED_COMPANY_MODIFY.TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="finish text-center">
      {{ 'CONTRACTED_COMPANY_MODIFY.FINISH_TEXT_1' | translate }}<br>{{ 'CONTRACTED_COMPANY_MODIFY.FINISH_TEXT_2' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()"  class="btn-grey">
            {{ 'CONTRACTED_COMPANY_MODIFY.FINISH_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>